module.exports = __webpack_public_path__ + "static/attentive-1a69f314e27bf325135004fb508a77d5.png";